import { defineComponent as _defineComponent } from 'vue'
import { Organization } from '@/modules/Organizations/types'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationsGridChip',
  props: {
    org: null
  },
  setup(__props: any) {

const { getOrgImage } = useImage()


return { __sfc: true,getOrgImage }
}

})